import ctaImage from "../assets/images/cta/cta-image.jpg";

const ctaData = {
  image: ctaImage,

  features: [
    {
      icon: "🏀",
      text: "5500+ Sports Projects Completed",
    },

    {
      icon: "⭐",
      text: "15+ Years Industry Experience",
    },

    {
      icon: "🇮🇳",
      text: "Serving Clients Across India",
    },

    {
      icon: "🛠️",
      text: "Premium Quality Construction",
    },
  ],
};

export default ctaData;
